import React from 'react';
import styles from './coloredStatus.module.css';

const ColoredStatus = ({ status, translatedStatus, className='' }) => {
  function computeClassName(status) {
    switch (status) {
      case 'Todo':
        return styles['colored-status-todo'];
      case 'Done':
        return styles['colored-status-done'];
      case 'Enabled':
        return styles['colored-status-enabled']
      case 'Disabled':
        return styles['colored-status-disabled']
      default:
        return '';
    }
  }

  return (
    <span className={`${styles['colored-status']} ${computeClassName(status)} ${className}`}>
      {translatedStatus}
    </span>
  );
};

export default ColoredStatus;
